let smoother = null;
document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger, TextPlugin, SplitText, ScrollSmoother);

  function initSmoother() {
    // Kill existing smoother if it exists
    if (smoother) {
      smoother.kill();
    }

    if (window.innerWidth > 990) {
      smoother = ScrollSmoother.create({
        wrapper: ".smooth-wrapper",
        content: ".smooth-content",
        smooth: 1.2,
        ease: "expo",
        smoothTouch: 0,
        ignore: "sticky-header",
      });
    } else {
      smoother = ScrollSmoother.create({
        wrapper: ".smooth-wrapper",
        content: ".smooth-content",
        smooth: 0,
        smoothTouch: 0.3,
        ease: "expo",
        ignore: "sticky-header",
      });
    }
  }
  // CRO: Loading screen removed, initialize ScrollSmoother directly
  initSmoother();

  // filter sticky
  let desktop_filter_content = document.querySelector("#ProductGridContainer");
  if (desktop_filter_content && window.innerWidth > 767) {
    ScrollTrigger.create({
      trigger: "#ProductGridContainer",
      start: "top top+=60", // When top of #product-grid hits top of viewport
      end: "bottom bottom", // Until bottom of wrapper reaches bottom of viewport
      pin: ".facets-vertical #FacetsWrapperDesktop", // Pin the actual left panel
      pinSpacing: false, // Remove extra spacing
      pinType: "transform",
    });
  } else if (desktop_filter_content && window.innerWidth <= 767) {
    ScrollTrigger.create({
      trigger: ".smooth-content",
      // start: "top bottom", // When top of #product-grid hits top of viewport
      start: () => {
        const el = document.querySelector("#main-collection-filters");
        return el.getBoundingClientRect().top - 100 + " bottom";
      },
      end: "bottom bottom", // Until bottom of wrapper reaches bottom of viewport
      pin: "#main-collection-filters", // Pin the actual left panel
      pinSpacing: false, // Remove extra spacing
      pinType: "transform",
    });
  }

  // bundle page
  let bundle_collection_grid_container = document.querySelector(
    "#bundle-collection-grid-container"
  );
  if (bundle_collection_grid_container && window.innerWidth > 767) {
    ScrollTrigger.create({
      trigger: "#bundle-collection-grid-container",
      start: "top top",
      end: "bottom bottom",
      pin: ".nlf-support-container",
      pinSpacing: false,
    });
  } else if (bundle_collection_grid_container && window.innerWidth <= 767) {
    ScrollTrigger.create({
      trigger: ".smooth-content",
      start: "top top",
      end: "bottom bottom",
      pin: ".nlf-support-container",
      pinSpacing: false,
    });
  }

  // let product_media_galary_sticky = document.querySelector(
  //   ".product__column-sticky"
  // );
  let productMediaGallerySticky = document.querySelector(".product__column-sticky");
  let container = document.querySelector(".product.product--left.product--row");
  if (productMediaGallerySticky && container && window.innerWidth > 750 ) {
    ScrollTrigger.create({
      trigger: container,
      // start: "top top",
      // end: "bottom bottom",
      start: "top top+=60",
      end: () => "+=" + (container.offsetHeight - productMediaGallerySticky.offsetHeight),
      pin: productMediaGallerySticky,
      pinSpacing: false,
      pinType: "transform"
    });
  }

  // Wrap in a function so you can call it again on resize if needed
  let scroll_trigger_menu = null;
  if (window.innerWidth >= 990) {
    scroll_trigger_menu = ScrollTrigger.create({
      trigger: "nav.header__inline-menu",
      start: "top top",
      end: "+=99999",
      pin: true,
      pinSpacing: false,
      pinType: "transform",
      invalidateOnRefresh: true,
      onEnter: (self) => {
        self.trigger.classList.add("custom-sticky-menu");
        self.trigger.style.zIndex = "9999";
        if (self.pin && self.pin.parentElement && self.pin.parentElement.classList.contains('pin-spacer')) {
          self.pin.parentElement.style.zIndex = "9999";
          self.pin.parentElement.style.overflow = "visible";
        }
      },
      onLeaveBack: (self) => {
        self.trigger.classList.remove("custom-sticky-menu");
        self.trigger.style.zIndex = "";
        if (self.pin && self.pin.parentElement && self.pin.parentElement.classList.contains('pin-spacer')) {
          self.pin.parentElement.style.zIndex = "";
          self.pin.parentElement.style.overflow = "visible";
        }
      },
    });
  } else {
    scroll_trigger_menu = ScrollTrigger.create({
      trigger: ".header-wrapper",
      start: "top top",
      end: "+=99999",
      pin: true,
      pinSpacing: false,
      pinType: "transform",
      onEnter: (self) => {
        self.trigger.classList.add("mobile-custom-sticky-menu");
      },
      onLeaveBack: (self) => {
        self.trigger.classList.remove("mobile-custom-sticky-menu");
      },
    });
  }

  // Re-meet pin posities nadat afbeeldingen/fonts klaar zijn met laden,
  // anders drift de transform-pin op de tweede scroll-cyclus.
  window.addEventListener("load", () => {
    ScrollTrigger.refresh();
  });
  let resizeRaf;
  window.addEventListener("resize", () => {
    cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(() => ScrollTrigger.refresh());
  });
});

